import React, { useEffect, useState } from 'react';

import CommonService from '../../../../services/commonService';
import MainTabsBodyCuponera from '../MainTabsBodyCuponera/MainTabsBodyCuponera';
import MainTabsBodyMyAccount from '../MainTabsBodyMyAccount/MainTabsBodyMyAccount';
import MainTabsBodyMyPromotions from '../MainTabsBodyMyPromotions/MainTabsBodyMyPromotions';
import MainTabsBodyMyTransactions from '../MainTabsBodyMyTransactions/MainTabsBodyMyTransactions';
import MainTabsBodyMyTrips from '../MainTabsBodyMyTrips/MainTabsBodyMyTrips';
import MainTabsMenu from '../MainTabsMenu/MainTabsMenu';

const operator = JSON.parse(localStorage.getItem('op'));

const menuItem = [
	{
		id: 1,
		icon: '/assets/linear/MyAccount-LinearIcons-MyAccount.svg',
		iconActive: '/assets/linear/MyAccount-LinearIcons-MyAccount.svg',
		name: 'MY_ACCOUNT',
		active: true,
	},
	{
		id: 3,
		icon: '/assets/linear/MyAccount-LinearIcons-MyTrips.svg',
		iconActive: '/assets/linear/MyAccount-LinearIcons-MyTrips.svg',
		name: 'MY_TRIPS',
		active: false,
	},
	{
		id: 4,
		icon: '/assets/linear/MyAccount-LinearIcons-MyMovements.svg',
		iconActive: '/assets/linear/MyAccount-LinearIcons-MyMovements.svg',
		name: 'MY_MOVEMENTS',
		active: false,
	},
	{
		id: 5,
		icon: '/assets/linear/MyAccount-LinearIcons-Promotions.svg',
		iconActive: '/assets/linear/MyAccount-LinearIcons-Promotions.svg',
		name: 'PROMOTIONS',
		active: false,
	},
];

if (operator && operator.is_couponera_enabled && operator.is_couponera_enabled) {
	menuItem.splice(1, 0, {
		id: 2,
		icon: '/assets/linear/MyAccount-LinearIcons-Cuponera.svg',
		iconActive: '/assets/linear/MyAccount-LinearIcons-Cuponera.svg',
		name: 'CUPONERA',
		active: false,
	});
}

function MainTabContainer(props) {
	const [menus, setMenus] = useState(menuItem);

	// COMPONENT DID MOUNT
	useEffect(() => {
		switch (props.params.tabName) {
			case 'trips':
				onMenuChange(1);
				break;
			case 'transactions':
				onMenuChange(2);
				break;
			case 'groups':
				onMenuChange(3);
				break;
			case 'promotions':
				onMenuChange(4);
				break;
			default:
				onMenuChange(0);
				break;
		}
	}, []);

	// COMPONENT DID UPDATE
	useEffect(() => {
		switch (props.params.tabName) {
			case 'trips':
				onMenuChange(1);
				break;
			case 'transactions':
				onMenuChange(2);
				break;
			case 'groups':
				onMenuChange(3);
				break;
			case 'promotions':
				onMenuChange(4);
				break;
			default:
				onMenuChange(0);
				break;
		}
	}, [props.params.tabName]);

	const onMenuChange = i => {
		props.onParentMenusChange('LEFT_MENU');

		let menusTemp = CommonService.copyObject(menus);
		for (let m of menusTemp) {
			m.active = false;
		}
		menusTemp[i].active = true;
		// this.setState({ menus: menus });
		setMenus(menusTemp);
	};

	// function to render the Tabs Body Item when the tab changes
	const renderBodyComponent = () => {
		let i;
		menus.map(val => {
			if (props.menuType && props.menuType == 'LEFT_MENU' && val.active) {
				i = val.id;
			}
		});

		switch (i) {
			case 1:
				return (
					<MainTabsBodyMyAccount
						history={props.history}
						t={props.t}
						onMenuChange={onMenuChange}
						actions={props.actions}
						data={props.data}
						metaData={props.metaData}
						operator={props.operator}
					/>
				);
			case 2:
				return (
					<MainTabsBodyCuponera
						history={props.history}
						t={props.t}
						onMenuChange={onMenuChange}
						actions={props.actions}
						data={props.data}
						metaData={props.metaData}
					/>
				);
			case 3:
				return (
					<MainTabsBodyMyTrips
						history={props.history}
						t={props.t}
						actions={props.actions}
						data={props.data}
						metaData={props.metaData}
						operator={props.operator}
					/>
				);
			case 4:
				return (
					<MainTabsBodyMyTransactions
						onTopIconChange={props.onTopIconChange}
						t={props.t}
						actions={props.actions}
						data={props.data}
						onMenuChange={() => onMenuChange(0)}
						operator={props.operator}
					/>
				);

			case 5:
				return (
					<MainTabsBodyMyPromotions
						t={props.t}
						actions={props.actions}
						data={props.data}
						operator={props.operator}
						onMenuChange={() => onMenuChange(0)}
					/>
				);
			default:
				return;
		}
	};

	const { t } = props;

	return (
		<div
			id="sub-details-section-my-account"
			className={
				'sub-details-section content-container  ' +
				(props.menuType && props.menuType == 'LEFT_MENU' ? 'kupos-card' : '')
			}
		>
			<MainTabsMenu
				operator={props.operator}
				menuType={props.menuType}
				t={t}
				menus={menus}
				onMenuChange={onMenuChange}
			/>

			<div className="my-acc-tab-content-container">{props.metaData && renderBodyComponent()}</div>
		</div>
	);
}

export default MainTabContainer;

// export default class MainTabContainer extends Component {
//   static propTypes = {
//     menuType: PropTypes.object.isRequired,
//     onParentMenusChange: PropTypes.func,
//     onTopIconChange: PropTypes.func,
//     actions: PropTypes.object,
//     data: PropTypes.object,
//     t: PropTypes.func,
//     params: PropTypes.object,
//   };

//   constructor(props) {
//     super(props);
//     this.state = {
//       menus: [
//         {
//           icon: '/svgs/my-account/my-account-orange.svg',
//           iconActive: '/svgs/my-account/my-account-grey.svg',
//           name: 'MY_ACCOUNT',
//           active: true,
//         },
//         {
//           icon: '/svgs/my-account/my-trips-orange.svg',
//           iconActive: '/svgs/my-account/my-trips-grey.svg',
//           name: 'MY_TRIPS',
//           active: false,
//         },
//         {
//           icon: '/svgs/my-account/my-movements-orange.svg',
//           iconActive: '/svgs/my-account/my-movements-grey.svg',
//           name: 'MY_MOVEMENTS',
//           active: false,
//         },
//         // {icon:'/svgs/my-account/my-groups-orange.svg',iconActive:'/svgs/my-account/my-groups-grey.svg',name:'MY_GROUPS',active:false},
//         {
//           icon: '/svgs/my-account/promotions-orange.svg',
//           iconActive: '/svgs/my-account/promotions-grey.svg',
//           name: 'PROMOTIONS',
//           active: false,
//         },
//       ],
//       classOfSubBody: 'null',
//     };
//   }

//   componentDidMount() {
//     switch (this.props.params.tabName) {
//       case 'trips':
//         this.onMenuChange(1);
//         break;
//       case 'transactions':
//         this.onMenuChange(2);
//         break;
//       case 'groups':
//         this.onMenuChange(3);
//         break;
//       case 'promotions':
//         this.onMenuChange(4);
//         break;
//       default:
//         this.onMenuChange(0);
//         break;
//     }
//     this.tabName = this.props.params.tabName;
//   }
//   componentDidUpdate() {
//     if (this.props.params.tabName !== this.tabName) {
//       switch (this.props.params.tabName) {
//         case 'trips':
//           this.onMenuChange(1);
//           break;
//         case 'transactions':
//           this.onMenuChange(2);
//           break;
//         case 'groups':
//           this.onMenuChange(3);
//           break;
//         case 'promotions':
//           this.onMenuChange(4);
//           break;
//         default:
//           this.onMenuChange(0);
//           break;
//       }
//       this.tabName = this.props.params.tabName;
//     }
//   }

//   onMenuChange = i => {
//     this.props.onParentMenusChange('LEFT_MENU');
//     let menus = CommonService.copyObject(this.state.menus);
//     for (let m of menus) {
//       m.active = false;
//     }
//     menus[i].active = true;
//     this.setState({ menus: menus });
//   };

//   // function to render the Tabs Body Item when the tab changes
//   renderBodyComponent = () => {
//     let i;
//     this.state.menus.map((val, k) => {
//       if (this.props.menuType && this.props.menuType.menuType == 'LEFT_MENU' && val.active) {
//         i = k;
//       }
//     });

//     switch (i) {
//       case 0:
//         return (
//           <MainTabsBodyMyAccount
//             history={this.props.history}
//             t={this.props.t}
//             onMenuChange={this.onMenuChange}
//             actions={this.props.actions}
//             data={this.props.data}
//             metaData={this.props.metaData}
//           />
//         );
//       case 1:
//         return (
//           <MainTabsBodyMyTrips
//             history={this.props.history}
//             t={this.props.t}
//             actions={this.props.actions}
//             data={this.props.data}
//             metaData={this.props.metaData}
//           />
//         );
//       case 2:
//         return (
//           <MainTabsBodyMyTransactions
//             onTopIconChange={this.props.onTopIconChange}
//             t={this.props.t}
//             actions={this.props.actions}
//             data={this.props.data}
//             onMenuChange={() => this.onMenuChange(0)}
//           />
//         );
//       // case 3:
//       //   return <MainTabsBodyMyGroups t={this.props.t} onMenuChange={() => this.onMenuChange(0)} />;
//       case 3:
//         return (
//           <MainTabsBodyMyPromotions
//             t={this.props.t}
//             actions={this.props.actions}
//             data={this.props.data}
//             onMenuChange={() => this.onMenuChange(0)}
//           />
//         );
//       default:
//         return;
//     }
//   };

//   render() {
//     const { t } = this.props;

//     console.log('Props in main tab container ---------', this.props);
//     return (
//       <div
//         id="sub-details-section-my-account"
//         className={
//           'sub-details-section content-container  ' +
//           (this.props.menuType && this.props.menuType.menuType == 'LEFT_MENU' ? 'kupos-card' : '')
//         }
//       >
//         <MainTabsMenu
//           menuType={this.props.menuType.menuType}
//           t={t}
//           menus={this.state.menus}
//           onMenuChange={this.onMenuChange}
//         />

//         <div className="my-acc-tab-content-container">
//           {this.props.metaData && this.renderBodyComponent()}
//         </div>
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabContainer/MainTabContainer.js